import React, { useState, useEffect } from 'react'
import Reusabletable from '../reusableforms/Reusabletable'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import files from "./../../../../assets/templates/register_template/Maternity_benefits.xlsx"
import { uploadMaternityBenefitsFile, getMaternityBenefits, updateMaternityBenefitsById, deleteMaternityBenefitsById, multiDeleteMaternityBenefits } from './../../../../services/register_redux/register_actions/MaternityBenefits.action';
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileformInputMatrix from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrix'
import ImportFileformInputMatrixclientData from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrixclientData'
import mainicon from "../../../../assets/register_assets/inputMatix/Maternity_Benefits/mainicon.png"
import { getUserRole } from "./../../../../services/global_redux/globale_actions/Role.action";
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action';
import Employee_code_icon from "../../../../assets/register_assets/inputMatix/Maternity_Benefits/Employee_code_icon.png"
import Client_id_icon from "../../../../assets/register_assets/inputMatix/Maternity_Benefits/Client_id_icon.png"
import Branch_id_icon from "../../../../assets/register_assets/inputMatix/Maternity_Benefits/Branch_id_icon.png"
import Employee_name_icon from "../../../../assets/register_assets/inputMatix/Maternity_Benefits/Employee_name_icon.png"


function MaternityBenefits({ setLoading, showSnackbar }) {
    const [getData, setGetData] = useState([])
    const [file, setFile] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const dispatch = useDispatch();
    const { date } = useParams();
    const [createData, setCreateData] = useState(null);
    const [editData, setEditData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const header = [
        { key: "emp_code", value: "Employee Code", input: "text", readOnly:true  ,icon: Employee_code_icon},
        // { key: "id", value: "Record ID", input: "number" },
        { key: "unit_id", value: "Branch ID", input: "text" ,readOnly:true ,icon: Branch_id_icon},
        { key: "client_id", value: "Organization ID", input: "text" ,readOnly:true ,icon: Client_id_icon},
        { key: "employee_name", value: "Employee Name", input: "text" ,icon: Employee_name_icon},
        { key: "establishment_name", value: "Establishment Name", input: "text" },
        { key: "work_nature", value: "Work Nature", input: "text" },
        { key: "father_or_husband_name", value: "Father/Husband Name", input: "text" },
        { key: "appointment_date", value: "Appointment Date", input: "date" },
        { key: "advance_maternity_benefit_amount", value: "Advance Maternity Benefit Amount", input: "number" },
        { key: "advance_maternity_benefit_date", value: "Advance Maternity Benefit Date", input: "date" },
        { key: "bonus_payment_amount_sec8", value: "Bonus Payment Amount (Sec 8)", input: "number" },
        { key: "bonus_payment_date_sec8", value: "Bonus Payment Date (Sec 8)", input: "date" },
        { key: "child_birth_date", value: "Child Birth Date", input: "date" },
        { key: "child_survives_benefit_period", value: "Child Survives Benefit Period", input: "text" },
        { key: "child_survives_benefit_recipient", value: "Child Survives Benefit Recipient", input: "text" },
        { key: "death_benefit_amount", value: "Death Benefit Amount", input: "number" },
        { key: "death_benefit_recipient", value: "Death Benefit Recipient", input: "text" },
        { key: "delivery_miscarriage_death_proof_date", value: "Delivery/Miscarriage Death Proof Date", input: "date" },
        { key: "discharge_dismissal_date", value: "Discharge/Dismissal Date", input: "date" },
        { key: "illness_leave_wages_amount_sec10", value: "Illness Leave Wages Amount (Sec 10)", input: "number" },
        { key: "illness_leave_wages_date_sec10", value: "Illness Leave Wages Date (Sec 10)", input: "date" },
        { key: "illness_proof_date_sec10", value: "Illness Proof Date (Sec 10)", input: "date" },
        { key: "leave_wages_payment_amount_sec9", value: "Leave Wages Payment Amount (Sec 9)", input: "number" },
        { key: "leave_wages_payment_date_sec9", value: "Leave Wages Payment Date (Sec 9)", input: "date" },
        { key: "notice_date_sec6", value: "Notice Date (Sec 6)", input: "date" },
        { key: "pregnancy_proof_date_sec6", value: "Pregnancy Proof Date (Sec 6)", input: "date" },
        { key: "subsequent_maternity_benefit_amount", value: "Subsequent Maternity Benefit Amount", input: "number" },
        { key: "subsequent_maternity_benefit_date", value: "Subsequent Maternity Benefit Date", input: "date" },
        { key: "woman_death_date", value: "Woman Death Date", input: "date" },
        { key: "employer_signature", value: "Employer Signature", input: "text" },
        { key: "employment_status_header_names", value: "Employment Status Header Names", input: "text" },
        { key: "employment_status_header_values", value: "Employment Status Header Values", input: "text" },
        { key: "inspector_remarks", value: "Inspector Remarks", input: "text" },
    ];
    
    const [actionChecked, setActionChecked] = useState("");
    

    const fetchdata = async () => {
        if (!date) return;
        setLoading(true);
        try {
            const response = await dispatch(getMaternityBenefits(date));
            const data = Array.isArray(response?.data) ? response.data : [];
            setGetData(data);
        } catch (err) {
            console.error("Failed to fetch maternity benefits:", err);
            setGetData([]);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchdata();
    }, [dispatch, date]);

    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);

            // const formData = new FormData();
            // formData.append('file', file);
    //         try {
    //             const response = await dispatch(uploadMaternityBenefitsFile(formData));
    //             console.log("upload employee master response", response);
    //             if (response.success == true) {
    //                 showSnackbar(response.message.data.data.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };



const downloadBase64Excel = (contentBase64, filename) => {
    try {
        // Decode base64 to binary
        const byteCharacters = atob(contentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'maternity_benefits_failed_rows.xlsx';
        document.body.appendChild(a); // Required for Firefox
        a.click();
        
        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        console.log('Error file downloaded successfully:', filename);
    } catch (e) {
        console.error('Download failed:', e);
        showSnackbar('Failed to download error file. Please try again.', 'error');
    }
};

const handleFileUpload = async () => {
    if (!file) {
        showSnackbar('Please select a file to upload', 'warning');
        return;
    }
    
    setLoading(true);
    
    try {
        const response = await dispatch(uploadMaternityBenefitsFile(file));
        console.log("Upload maternity benefits response:", response);
        
        // ============================================================
        // HANDLE SUCCESS RESPONSE (status 200)
        // ============================================================
        if (response.success === true) {
            const data = response.data; // This is the backend response object
            setActionChecked("create");
            console.log("Response data:", data);
            
            // Check if we have the expected response structure
            if (!data) {
                showSnackbar('Unexpected response format', 'error');
                setLoading(false);
                return;
            }
            
            // Extract counts
            const insertedCount = data.inserted_count || 0;
            const failedCount = data.failed_count || 0;
            const totalRows = insertedCount + failedCount;
            
            // CASE 1: Full success (all rows inserted)
            if (insertedCount > 0 && failedCount === 0) {
                showSnackbar(
                    data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                    'success'
                );
                
                // Refresh the data table
                fetchdata();
                setFile(null);
            }
            
            // CASE 2: Partial success (some rows inserted, some failed)
            else if (insertedCount > 0 && failedCount > 0) {
                showSnackbar(
                    `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                    `${failedCount} record(s) failed. Downloading error file...`,
                    'warning',
                    6000 // Show for 6 seconds
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite failed rows');
                }
                
                // Refresh the data table (to show successfully inserted rows)
                fetchdata();
                // Don't clear the file - user might want to fix and re-upload
            }
            
            // CASE 3: Complete failure (all rows failed)
            else if (insertedCount === 0 && failedCount > 0) {
                showSnackbar(
                    `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                    `Downloading error file with details...`,
                    'error',
                    6000
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite all rows failing');
                    // Fallback: show the message if available
                    if (data.message) {
                        showSnackbar(data.message, 'error', 8000);
                    }
                }
            }
            
            // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
            else {
                showSnackbar(
                    data.message || 'Upload completed with unexpected result', 
                    'info'
                );
            }
            
            setLoading(false);
        }
        
        // ============================================================
        // HANDLE ERROR RESPONSE (non-200 status)
        // ============================================================
        else {
            const errorMsg = response.error || 'Upload failed';
            
            // Handle different error types
            if (typeof errorMsg === 'string') {
                showSnackbar(errorMsg, 'error');
            } else if (Array.isArray(errorMsg)) {
                // If backend returns array of errors
                const displayError = errorMsg.slice(0, 3).join('; ') + 
                    (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                showSnackbar(displayError, 'error');
            } else if (typeof errorMsg === 'object' && errorMsg.error) {
                showSnackbar(errorMsg.error, 'error');
            } else {
                showSnackbar('An error occurred during upload', 'error');
            }
            
            setLoading(false);
        }
        
    } catch (error) {
        // This catches any unexpected errors in the frontend code
        console.error('Upload error:', error);
        showSnackbar('An unexpected error occurred. Please try again.', 'error');
        setLoading(false);
    }
};




    const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteMaternityBenefits(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }

    const handleSaveClick = async (e) => {
        setLoading(true);
        try {
            const response = await dispatch(updateMaternityBenefitsById(editedValues.id, editedValues));
            console.log("kjjfjfjfkjf", response);
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            } else {
                showSnackbar(response.message.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(deleteMaternityBenefitsById(id));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());    
            const rawPermissions = response?.data?.permissions;
    
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
    
            parsedPermissions.forEach((item) => {
                const { section, module, sub_module } = item;
    
                if (section === "InputMatrix" && module === "InputMatrix") {
                    const employeePermission = sub_module.find(sub => sub.name === 'Maternity Benefits');
                    if (employeePermission?.action) {
                        setCreateData(employeePermission.action.create);
                        setEditData(employeePermission.action.edit);
                        setDeleteData(employeePermission.action.delete);
                    }
                }
            });
    
        } catch (err) {
            console.error("Failed to fetch permissions:", err);
        }
    };
    
    
    const fetchcurrmonth = async () => {
        try {
            const response = await dispatch(getCurrentMonth());
            if(date === new Date(response.data[0].current_month).toISOString().split('T')[0]){
                getUserPermission();
            }
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    };
    useEffect(() => {
        fetchcurrmonth();
    }, [dispatch]);
    return (
        <div className='container-fluid '>
            {/* <Reusabletable
                data={getData}
                header={header}
                setFile={setFile}
                handleFileUpload={handleFileUpload}
                submitdelete={submitdelete}
                handleSaveClick={handleSaveClick}
                setEditableRow={setEditableRow}
                editableRow={editableRow}
                setEditedValues={setEditedValues}
                editedValues={editedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                title={'Maternity Benefits'}
                setLoading={setLoading}
                filestemp={files}
                showSnackbar={showSnackbar}
                date={date}
            /> */}
            {createData ? 
            // <ImportFileform
            //     setFiledata={setFile}
            //     title={'Maternity Benefits'}
            //     filestemp={files}
            //     handleFileUpload={handleFileUpload}

            // />
            <ImportFileformInputMatrix
                setFiledata={setFile}
                title={'Maternity Benefits'}
                filestemp={files}
                handleFileUpload={handleFileUpload}
                date={date}
                File={file}
            />:<ImportFileformInputMatrixclientData
                date={date}
                
            />
            }
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'Maternity Benefits'}
            data={getData}
            setEditableRow={setEditableRow}
            setEditedValues={setEditedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            editableRow={editableRow}
            setLoading={setLoading}
            editedValues={editedValues}
            getEditPermission = {editData}
            getDeletePermission = {deleteData}
            date={date}
            submitdelete={submitdelete}
            handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}
            mainIconColor={"#bd0084"}
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}
            createOrfilterComp={
                <></>
            }
            />
        </div>
    )
}


export default MaternityBenefits
